import { render } from "./AboutParcel.vue?vue&type=template&id=e261cc62&scoped=true"
import script from "./AboutParcel.vue?vue&type=script&lang=js"
export * from "./AboutParcel.vue?vue&type=script&lang=js"

import "./AboutParcel.vue?vue&type=style&index=0&id=e261cc62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e261cc62"]])

export default __exports__